import {select, take, fork, put} from 'redux-saga/effects';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as serviceCaseActionTypes from '../serviceCaseActionTypes';

/*
* Service case: get vehicle manufacturers flow (uses silverDAT API)
*/
const getVehicleManufacturersFlow = function* getVehicleManufacturersFlow() {
    const {serviceManager} = yield select(state => state.application);
    const silverDATService = serviceManager.loadService('silverDATService');

    while (true) {
        const {payload} = yield take(serviceCaseActionTypes.GET_VEHICLE_MANUFACTURERS);
        const {vehicleType} = payload;

        yield fork(
            fetchRequest,
            serviceCaseActionTypes.FETCH_VEHICLE_MANUFACTURERS_REQUEST,
            silverDATService.getVehicleManufacturers, {
                vehicleType,
            },
        );

        const responseAction = yield take([
            serviceCaseActionTypes.FETCH_VEHICLE_MANUFACTURERS_REQUEST_SUCCEEDED,
            serviceCaseActionTypes.FETCH_VEHICLE_MANUFACTURERS_REQUEST_FAILED,
        ]);

        if (!responseAction.error) {
            const {response} = responseAction.payload;
            const {vehicleManufacturers} = response;

            yield put({
                type: serviceCaseActionTypes.STORE_VEHICLE_MANUFACTURERS,
                payload: {vehicleManufacturers, vehicleType},
            });
        }
    }
};

export default getVehicleManufacturersFlow;
